import { render, staticRenderFns } from "./SContactSupplier.vue?vue&type=template&id=806eb756"
import script from "./SContactSupplier.vue?vue&type=script&lang=js"
export * from "./SContactSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports